module.exports = __webpack_public_path__ + "img/del.d4747cb2.svg";